export enum OpportunitySourceEnum {
  TACKLE = 'TACKLE',
  AWS_ACE = 'AWS_ACE',
}
